import { useEffect, useRef, type RefObject } from 'react';
import { setup } from './use-required-video-yt-attach';
import type { SeekFn } from '@/types/required-video';

type Args = {
  iframeRef: RefObject<HTMLIFrameElement | null>;
  onReady: (seek: SeekFn) => void;
  onTime: (t: number, d: number) => void;
};

export function useYTAdapter(args: Args): void {
  const onReadyRef = useRef(args.onReady);
  const onTimeRef = useRef(args.onTime);
  useEffect(() => {
    onReadyRef.current = args.onReady;
    onTimeRef.current = args.onTime;
  }, [args.onReady, args.onTime]);
  useEffect(
    () => setup(args.iframeRef, { onReadyRef, onTimeRef }),
    [args.iframeRef]
  );
}
